(function () {
  if (window.__pvUpsellInit) return;
  window.__pvUpsellInit = true;

  document.addEventListener('click', async function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.pv-upsell-add') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = '…';

    try {
      var sectionIds = Array.prototype.map
        .call(document.querySelectorAll('cart-items-component'), function (el) {
          return el.dataset.sectionId;
        })
        .filter(Boolean);

      var fd = new FormData();
      fd.set('id', btn.dataset.variantId);
      fd.set('quantity', '1');
      if (sectionIds.length) fd.set('sections', sectionIds.join(','));

      var addUrl = ((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add') + '.js';
      var res = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      var data = await res.json();

      if (data.status) {
        btn.disabled = false;
        btn.textContent = '+';
        return;
      }

      if (!sectionIds.length) {
        window.location.reload();
        return;
      }

      var cart = await fetch('/cart.js').then(function (r) {
        return r.json();
      });

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'pv-upsell',
            data: {
              source: 'product-form-component',
              itemCount: 1,
              variantId: btn.dataset.variantId,
              sections: data.sections
            }
          }
        })
      );
    } catch (err) {
      console.error('pv-upsell', err);
      btn.disabled = false;
      btn.textContent = '+';
    }
  });
})();
